import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_PIPELINE_FUNNEL_ACTION_TYPE } from '../actions/pipelineFunnel.actions';

const initialState = null;

const pipelineFunnelReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_PIPELINE_FUNNEL_ACTION_TYPE.SET_PIPELINE_FUNNEL:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default pipelineFunnelReducer;
